import React, { useEffect, useState } from "react";
import { Container, Row, Col, Nav } from "react-bootstrap";
import "../../css/Tab.css";
import { PRIVACYPOLICY, TERMSOFUSE } from "../../../services/UserRoutePath";

import { useLocation, useNavigate, useParams } from "react-router";

const TermOfUse = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <>
      <Container className="my-5">
        <Row>
          <Col>
            <h1 className="mb-4">Terms of Use</h1>
            <p>
              Please review this information before using this website. The
              material on this website (www.bridgelinebilling.com) is provided
              by Bridgeline Billing, LLC (“Bridgeline”) as a service to its
              customers and may be used for informational purposes only. By
              continuing use of this website or downloading any materials from
              the website, you agree to these terms. If you do not agree to
              them, do not use the website or download any materials from it.
            </p>
            <p>
              By updating this posting, Bridgeline may, at any time, modify the
              website and the terms governing its use. You should visit this
              page from time to time to review these terms. Certain provisions
              may be superseded by expressly designated legal notices or terms
              located on particular pages of the website.
            </p>

            <h2>Restriction on Use</h2>
            <p>
              All materials published on the website, including, but not limited
              to trademarks, service marks, photographs, videos, diagrams, text,
              and illustrations (collectively, the “content”), is the property
              of Bridgeline unless otherwise indicated. Any use of the material
              on this website, including its reproduction, modification,
              distribution, transmission, republication, display, or
              performance, is strictly prohibited without the express written
              consent of Bridgline. Nothing contained in this website shall be
              construed in any way as conferring any license or right under any
              patent, copyright, or trademark of Bridgeline. All rights not
              expressly granted herein are reserved.
            </p>

            <h2>Copyright</h2>
            <p>
              All content on the website is copyrighted and protected by
              copyright laws and treaty provisions. It may not be copied,
              reproduced, modified, published, uploaded, posted, transmitted, or
              distributed in any way without the prior written permission of
              Bridgeline or as expressly provided herein.
            </p>

            <h2>Disclaimer</h2>
            <p>
              Bridgeline makes every effort to provide the most current,
              accurate and useful information on the website. However,
              information on the website may contain technical inaccuracies or
              typographical errors. Information may be changed or updated
              without notice.
            </p>
            <p>
              THE MATERIALS IN THE WEBSITE ARE PROVIDED ON AN “AS IS” BASIS.
              BRIDGELINE MAKES NO REPRESENTATIONS OR WARRANTIES OF ANY KIND,
              EXPRESS OR IMPLIED, AS TO THE OPERATION OR CONTENT OF THE WEBSITE
              OR ANY OTHER WEBSITE TO WHICH IT IS LINKED. BRIDGELINE DISCLAIMS
              ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO,
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
              PURPOSE. BRIDGELINE DOES NOT WARRANT OR REPRESENT THAT THE
              INFORMATION IS ACCURATE OR RELIABLE OR THAT THE WEBSITE WILL BE
              FREE OF ERRORS OR VIRUSES. ELECTRONIC MAIL SENT TO BRIDGELINE IS
              NOT NECESSARILY SECURE AND USERS SHOULD AVOID SENDING INFORMATION
              OF A SENSITIVE OR CONFIDENTIAL NATURE.{" "}
            </p>
            <p>
              Under no circumstances, including but not limited to negligence,
              will Bridgeline directors, officers, employees and agents be
              liable for any damages of any kind arising from the use or
              inability to use the website or any website to which it is linked,
              including, but not limited to, direct, indirect, punitive, special
              and consequential damages.
            </p>

            <h2>Third-Party Websites</h2>
            <p>
              Since Bridgeline does not control third-party websites, we
              encourage you to review the policies posted on (all) third-party
              websites. When you access a third-party website, be aware it is
              independent from Bridgeline and that Bridgeline has no control
              over the content or privacy practices on other websites. In
              addition, a link on our website to a third-party website does not
              mean that Bridgeline endorses or accepts any responsibility for
              the content or use of such website.
            </p>

            <h2>Linking to the Bridgeline Website</h2>
            <p>
              Bridgeline permits links from other websites in accordance with
              the following conditions: Any link to the website must be a
              text-only link clearly marked “Official Bridgeline Website”. The
              position, appearance, and other aspects of the link may not damage
              or dilute the Bridgeline name and brand or be displayed in any
              manner that is likely to cause confusion among the public or
              disparage or discredit Bridgeline. Clearance, position, and other
              attributes of the link may not create the false impression that an
              organization or entity is sponsored by, affiliated, or associated
              with Bridgeline. The linking website must include obvious language
              stating that it is an unofficial website and is not endorsed by,
              sponsored by, or affiliated with Bridgeline and that any views
              expressed on the website are not those of Bridgeline. When
              selected by a user, the link must display the Bridgeline website
              full-screen and not within a frame on the linking website. These
              conditions do not grant license or any other rights to use any
              Bridgeline trademarks. Bridgeline reserves the right, at its sole
              discretion, to terminate or modify its consent to the link at any
              time or take action against any use that does not conform to these
              conditions.
            </p>

            <h2>General Terms and Conditions</h2>
            <p>
              By using this website, you agree to comply with all applicable
              laws, rules and regulations in accessing and/or using this website
              and/or any information available via this website. In addition,
              your use of this website is conditioned on your compliance with
              the following rules of conduct. You agree not to:
            </p>
            <ol>
              <li>Use this website for any fraudulent or unlawful purpose.</li>
              <li>
                Impersonate any person or entity, including, but not limited to,
                any Bridgeline employee, agent, or representative; falsely state
                or otherwise misrepresent your identity or your affiliation with
                any person or entity; or express or imply that Bridgeline
                endorses any statement you make.
              </li>
              <li>Interfere with or disrupt the operation of this website.</li>
              <li>
                Transmit or otherwise make available in connection with this
                website any spam, virus, worm, Trojan Horse, or other harmful
                code.
              </li>
              <li>
                Restrict or inhibit any other person from using this website,
                including by means of hacking or defacing any portion of this
                website.
              </li>
              <li>
                Interfere with or violate the right to privacy or other rights
                of any other visitor to this website, or harvest or collect
                personally identifiable information about such visitors or
                users, or about Bridgeline, its owners, directors, officers,
                agents, employees and representatives identified on this
                website, without their express consent.
              </li>
              <li>
                Sell, resell, demonstrate, market, transfer, license, or exploit
                for any commercial purposes any use of or access to this website
                or the information found on this website.
              </li>
              <li>
                Modify, reuse, adapt, translate, reverse engineer, decompile, or
                disassemble any portion of this website.
              </li>
              <li>
                Frame or mirror all or any part of this website without our
                prior express written authorization.
              </li>
              <li>
                Crawl, scrape, or otherwise cache any content from this website.
              </li>
              <li>
                Hold Bridgeline responsible in any way for any damage or harm
                caused to you by your use of this website.
              </li>

              <p>
                This Agreement is governed by and shall be construed in
                accordance with the laws of the State of Utah, United States of
                America, without regards to its principles of conflicts of law.
                In the event of a dispute arising under or relating to this
                Agreement or this website, you agree to the exclusive
                jurisdiction of the federal and state courts located in the
                District of Utah in the State of Utah, and waive any
                jurisdictional, venue, or inconvenient forum objections to such
                courts.
              </p>
            </ol>
            <p>
              If any provision of this Agreement is found for any reason to be
              unlawful, void, or unenforceable, then that provision will be
              deemed severable from this Agreement and will not affect the
              validity and enforceability of any remaining provision. Any
              heading, caption or section title contained herein is inserted
              only as a matter of convenience, and in no way defines or explains
              any section or provision hereof. A party’s failure to insist upon
              or enforce strict performance of any provision of this Agreement
              shall not be construed as a waiver of any provision or right.
              This, together with any of our policies referred to herein, is the
              entire Agreement between you and Bridgeline relating to your use
              of this website, and supersedes any and all prior or
              contemporaneous written or oral Agreements between you and
              Bridgeline regarding the same subject matter (except other
              written, fully-executed contracts between you and Bridgeline,
              including but not limited to click-wrap agreements or any other).
              Neither the course of conduct between you and Bridgeline, nor
              trade practice, shall act to modify any provision of this
              Agreement. Bridgeline shall not be liable for any failure to
              perform due to causes beyond its reasonable control. No promise,
              representation, warranty, or covenant not included in this
              Agreement may be relied upon by you. This Agreement shall not
              create any rights in or inure to the benefit of any third party.
              If you use this website as an employee of a company, you represent
              that you are able to bind your employer to the terms of this
              Agreement and such use shall constitute such a binding agreement
              and representation. A breach of this Agreement entitles Bridgeline
              to attorneys’ fees and reasonable costs to enforce the terms of
              this Agreement. All rights not expressly granted by Bridgeline
              herein, are hereby reserved.
            </p>

            <h2>GDPR Compliance</h2>
            <h5>What do we do with your information?</h5>
            <p>
              If you choose to fill in an electronic form on our website, we
              will store that information for six (6) months and only use it for
              the purpose of contacting you in relation to that enquiry. If you
              enter into a business relationship with us, we will store that
              information for the duration of the relationship, which may exceed
              six (6) months. When you browse our site, we also automatically
              receive your computer’s internet protocol (IP) address in order to
              provide us with information that helps us learn about your browser
              and operating system. With your explicit permission, we may send
              you communications about our products and other updates.
            </p>

            <h5>What do we do with your information?</h5>
            <p>
              If you choose to fill in an electronic form on our website, we
              will store that information for six (6) months and only use it for
              the purpose of contacting you in relation to that enquiry. If you
              enter into a business relationship with us, we will store that
              information for the duration of the relationship, which may exceed
              six (6) months. When you browse our site, we also automatically
              receive your computer’s internet protocol (IP) address in order to
              provide us with information that helps us learn about your browser
              and operating system. With your explicit permission, we may send
              you communications about our products and other updates.
            </p>

            <h5>Consent</h5>
            <p>
              How do you get my consent? When you provide us with personal
              information, we ask you to explicitly consent to our collecting it
              and using it for that specific reason only. If we ask for your
              personal information for a secondary reason, like marketing, we
              will either ask you directly for your expressed consent, or
              provide you with an opportunity to say no.
            </p>

            <h5>How do I withdraw my consent?</h5>
            <p>
              If after you opt-in, you change your mind, you may withdraw your
              consent for us to contact you, for the continued collection, use
              or disclosure of your information, at any time, by contacting us
              at www.bridgelinebilling.com.
            </p>

            <h5>Disclosure</h5>
            <p>
              We may disclose your personal information if we are required by
              law to do so.
            </p>

            <h5>Data Storage</h5>
            <p>
              Your data is stored through Bridgeline’s data storage and
              databases. We store your data on a secure server behind a
              firewall.
            </p>

            <h5>Third-party services & links</h5>
            <p>
              In general, the third-party providers used by us will only
              collect, use and disclose your information to the extent necessary
              to allow them to perform the services they provide to us. When you
              click on links on our site, they may direct you away from our
              site. We are not responsible for the privacy practices of other
              sites and encourage you to read their privacy statements.
            </p>

            <h5>Security</h5>
            <p>
              To protect your personal information, we take reasonable
              precautions and follow industry best practices to make sure it is
              not inappropriately lost, misused, accessed, disclosed, altered or
              destroyed.
            </p>

            <h2>Cookies</h2>
            <p>
              Bridgeline may use cookies to help Bridgeline identify and track
              visitors, their usage of the Bridgeline website and their website
              preferences. Bridgeline visitors who do not wish to have cookies
              placed on their computers should set their browsers to refuse
              cookies before using Bridgeline’s website. Following are examples
              of the cookies that we use.{" "}
              <ul>
                <li>
                  Strictly Necessary Cookies – we use some cookies to ensure
                  that our website delivers you information and services
                  securely and optimally.
                </li>
                <li>
                  Google Analytics – we use Google Analytics to measure how our
                  site is used by visitors and to generate reports for our own
                  use. Google Analytics does not collect any personally
                  identifiable information about you.
                </li>
              </ul>
            </p>
            <h2>Changes to the privacy policy and terms of use.</h2>
            <p>
              We reserve the right to modify these terms of use and the privacy
              policy at any time, so please review it frequently. Changes and
              clarifications will take effect immediately upon their posting on
              the website. If we make material changes to this policy, we will
              notify you here that it has been updated, so that you are aware of
              what information we collect, how we use it, and under what
              circumstances, if any, we use and/or disclose it.
            </p>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default TermOfUse;
